import React from 'react';
import './Body.css';

function Body() {
  return (
      <>
      <div className='container-text'>
        <div className='inner-text'>
            <h1 className='body-title'>Why Is Nutrition Important?</h1>
                <p>Most people know good nutrition and physical activity can help maintain a 
                <br/> healthy weight. But the benefits of good nutrition go beyond weight. <br/>Good nutrition can help:
                </p>
                <div className='inner-text-list'>
                    <ul className='text-list'>
                        <li className='list-text'>Reduce the risk of some diseases, including <br/>heart disease, diabetes, 
                        stroke, some cancers, and osteoporosis</li>
                        <li className='list-text'>Reduce high blood pressure</li>
                        <li className='list-text'>Lower high cholesterol</li>
                        <li className='list-text'>Improve your well-being</li>
                        <li className='list-text'>Improve your ability to fight off illness</li>
                        <li className='list-text'>Improve your ability to recover from illness or injury</li>
                        <li className='list-text'>Increase your energy level</li>
                    </ul>
                </div>

        </div>
                <div className='outer'>
                    <img className='pic-one' src='./images/image_one.jpg' alt='image_one' />
                </div>
      </div>
      </>
  )
}

export default Body